import Service from '@ember/service';
import { service } from '@ember/service';
import CircuitService from './circuit';
import StateService from './state';

export default class DisplayOptionsService extends Service {
  @service declare state: StateService;
  @service declare circuit: CircuitService;
  fundamentalFilter_INDEX = 0;
  dacImagesFilter_INDEX = 1;
  pptSpurFilter_INDEX = 2;
  harmonicsFilter_INDEX = 3;
  harmonics2Filter_INDEX = 4;
  harmonics3Filter_INDEX = 5;

  get fundamentalFilter(): boolean {
    return this.state.signalDisplayOptions.substr(this.fundamentalFilter_INDEX, 1) === '1';
  }

  set fundamentalFilter(value: boolean) {
    this.state.signalDisplayOptions = this.replaceAndEncode(this.fundamentalFilter_INDEX, value);
    this.circuit.updateParams('rso');
  }

  get dacImagesFilter(): boolean {
    return this.state.signalDisplayOptions.substr(this.dacImagesFilter_INDEX, 1) === '1';
  }

  set dacImagesFilter(value: boolean) {
    this.state.signalDisplayOptions = this.replaceAndEncode(this.dacImagesFilter_INDEX, value);
    this.circuit.updateParams('rso');
  }

  get pptSpurFilter(): boolean {
    return this.state.signalDisplayOptions.substr(this.pptSpurFilter_INDEX, 1) === '1';
  }

  set pptSpurFilter(value: boolean) {
    this.state.signalDisplayOptions = this.replaceAndEncode(this.pptSpurFilter_INDEX, value);
    this.circuit.updateParams('rso');
  }

  get harmonicsFilter(): boolean {
    return this.state.signalDisplayOptions.substr(3, 1) === '1';
  }

  set harmonicsFilter(value: boolean) {
    this.state.signalDisplayOptions = this.replaceAndEncode(this.harmonicsFilter_INDEX, value);
    this.circuit.updateParams('rso');
  }

  get harmonics2Filter(): boolean {
    return this.state.signalDisplayOptions.substr(4, 1) === '1';
  }

  set harmonics2Filter(value: boolean) {
    this.state.signalDisplayOptions = this.replaceAndEncode(this.harmonics2Filter_INDEX, value);
    this.circuit.updateParams('rso');
  }

  get harmonics3Filter(): boolean {
    return this.state.signalDisplayOptions.substr(5, 1) === '1';
  }

  set harmonics3Filter(value: boolean) {
    this.state.signalDisplayOptions = this.replaceAndEncode(this.harmonics3Filter_INDEX, value);
    this.circuit.updateParams('rso');
  }

  get harmonicDB(): number {
    return this.state.harmonicDB;
  }

  set harmonicDB(value: number) {
    this.state.harmonicDB = value;
    this.circuit.updateParams('harmonicDB');
  }

  replaceAndEncode(index: number, value: boolean): string {
    const results = [
      this.fundamentalFilter,
      this.dacImagesFilter,
      this.pptSpurFilter,
      this.harmonicsFilter,
      this.harmonics2Filter,
      this.harmonics3Filter,
    ];

    results[index] = value;
    let resultString = '';
    for (let i = 0; i < results.length; i++) {
      resultString += results[i] ? '1' : '0';
    }

    return resultString;
  }
}

declare module '@ember/service' {
  interface Registry {
    'display-options': DisplayOptionsService;
  }
}
